module.exports = __webpack_public_path__ + "static/media/administrationSupport.b6af0fba.svg";